import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { injectIntl } from 'react-intl';
// Cloud React components
import { Button, Input, Form } from 'Components';
import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import { NotificationManager } from 'Components/Notifications';
import { Grid } from '@mui/material';
import IconPicker from 'Modules/.common/components/IconPicker';

//actions
import {
    mapGeofencesOpenEditCreateGeofenceGroupModal,
    mapGeofencesGetGeofenceGroup,
    mapGeofencesEditCreateGeofenceGroup,
    getGeofenceGroups,
    updateGeofenceGroupInRedux,
    clearRedux
} from 'Redux/actions';

const GeofenceGroupCreateEdit = (props) => {
    const dispatch = useDispatch();
    const { intl } = props;
    const { messages } = intl;

    const editCreateLandmarkGroup = useRef();

    const {
        open,
        id,
        geofenceGroup,
        loadingGeofenceGroup,
        response,
        loadingResponse
    } = useSelector((state) => state.realtimeMapGeofenceGroupCreateEditModuleRedux);

    const { geofencesGroups, loadingGeofenceGroup : loadingGeofenceGroupMain } = useSelector((state) => state.realtimeMapNewGeofenceModuleRedux);

    const [formData, setFormData] = useState({ color: '8677D9' });

    useEffect(() => {
        dispatch(getGeofenceGroups());

        return () => {
            setFormData({ color: '8677D9' });
            dispatch(clearRedux("MAP_GEOFENCES_EDIT_CREATE_GEOFENCE_GROUP"));
        }
    }, []);

    useEffect(() => {
        if (id && open) {
            dispatch(mapGeofencesGetGeofenceGroup(id));
        }
    }, [id, open]);

    useEffect(() => {
        if (response && open) {
            if (response.error) {
                NotificationManager.error(
                    response.message || messages['errorMessage'],
                    messages['error'],
                    3000,
                    null,
                    null,
                    'warning',
                );
                dispatch(clearRedux("MAP_GEOFENCES_EDIT_CREATE_GEOFENCE_GROUP", { response: null }));
            } else {
                NotificationManager.success(
                    messages['mapGeofenceCreateEditGeofenceGroup_success'],
                    messages['success'],
                    3000,
                    null,
                    null,
                    'success',
                );

                dispatch(updateGeofenceGroupInRedux(geofenceGroup ? "update" : "add", response));
                dispatch(getGeofenceGroups());
                handleClose();
            }
        }
    }, [response, open]);

    useEffect(() => {
        if (geofenceGroup && open) {
            if (geofenceGroup.error) {
                NotificationManager.error(
                    messages['errorMessage'],
                    messages['error'],
                    3000,
                    null,
                    null,
                    'warning',
                );
            } else {
                //load the information from Geofence
                setFormData({ ...geofenceGroup });
            }
        }
    }, [geofenceGroup, open]);

    /****************************************************
     * Save the Geofence Elements
     ****************************************************/
    const onSubmit = useCallback(() => {
        let filteredGeofences = [ ...geofencesGroups ];
        if (geofenceGroup) {
            filteredGeofences = geofencesGroups.filter(lg => lg?.id != geofenceGroup?.id);
        }

        let groupExists = filteredGeofences.find(geofenceGroup => geofenceGroup?.name?.toLowerCase() === formData?.name?.toLowerCase());
        if (groupExists) {
            NotificationManager.warning(
                messages['mapGeofenceCreateEditGeofenceGroup_groupAlreadyExists'],
                messages['error'],
                3000,
                null,
                null,
                'success',
            );
            return;
        }
        dispatch(mapGeofencesEditCreateGeofenceGroup({
            ...formData
        }));
    });

    const handleClose = useCallback((e) => {
        if (e) e.preventDefault();
        setFormData({ color: '8677D9' });
        dispatch(mapGeofencesOpenEditCreateGeofenceGroupModal(false));
        dispatch(clearRedux("MAP_GEOFENCES_EDIT_CREATE_GEOFENCE_GROUP"));
    });

    const title = geofenceGroup ? `${messages['mapGeofenceCreateEditGeofenceGroup_editTitle']} '${geofenceGroup?.name}'` : `${messages['mapGeofenceCreateEditGeofenceGroup_createTitle']}`;

    return (
        <Modal
            title={title}
            open={open}
            loading={loadingGeofenceGroup || loadingResponse || loadingGeofenceGroup || loadingGeofenceGroupMain}
            position="right"
            size="small"
            className="modal-top-0"
            headerStyle={{
                top: 0
            }}
            handleClose={handleClose}
        >
            <ModalBody>
                <div style={{ padding: '18px 24px 24px 24px', height: 650 }}>
                    <Form ref={editCreateLandmarkGroup} onValidSubmit={onSubmit}>
                        <div style={{ width: '100%' }}>
                            <Grid
                                container
                                direction="row"
                                justifyContent="flex-start"
                                alignItems="flex-start"
                            >
                                <Grid item>
                                    <div className="form-item">
                                        <IconPicker
                                            color={formData?.color}
                                            icon={null}
                                            options={["color"]}
                                            onChange={(color) => setFormData({ ...formData, color: color })}
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs>
                                    <Input
                                        id="name"
                                        type={geofenceGroup ? "inline" : "text"}
                                        placeholder={messages['mapGeofenceCreateEditGeofenceGroup_name']}
                                        value={formData.name || ""}
                                        onChange={(value) => setFormData({ ...formData, name: value })}
                                        required
                                        requiredMessage={messages['required_field']}
                                        maxLength={50}
                                    />
                                </Grid>
                            </Grid>
                        </div>
                    </Form>
                </div>
            </ModalBody>

            <ModalFooter style={{ bottom: 50 }}>
                <Button
                    disabled={loadingGeofenceGroup || loadingResponse || loadingGeofenceGroup || loadingGeofenceGroupMain}
                    onClick={handleClose}
                    className="btn-cancel"
                >
                    {messages['cancel']}
                </Button>

                <Button
                    disabled={loadingGeofenceGroup || loadingResponse || loadingGeofenceGroup || loadingGeofenceGroupMain}
                    onClick={(e) => {
                        if (e) e.preventDefault();
                        editCreateLandmarkGroup.current.submit();
                    }}
                    className="btn-blue"
                >
                    {messages['save']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default injectIntl(GeofenceGroupCreateEdit);